export const Breakpoints = {
    xxxs: '380px',
    xxs: '480px',
    xs: '640px',
    sm: '800px',
    md: '1000px',
    lg: '1200px',
    xl: '1600px',
};
//# sourceMappingURL=Breakpoints.js.map